<div class="edit-part-panel">
    <h4 class="heading-edit">Edit part</h4>

    <div class="help_section">
        <p translate *ngIf="partStatus == 'edit_requested'">Help.Text.For.Edit.Part</p>
        <p translate *ngIf="partStatus == 'edit_ordered' || partStatus == 'edit_available' || partStatus === 'edit_installed' || partStatus === 'edit_pickUp'">You.can.edit.the.cost.and.sale.price.for.this.part.Type.in.your.changes.below.and.click.Save</p>
    </div>

    <form [formGroup]="form" class="part-form-class">
        <!-- Quantity -->
        <div *ngIf="showQuantity">
            <label>Quantity <span class="required">*</span></label>
            <input type="text" formControlName="Quantity" class="full-width"
                   [class.with-error]="f.Quantity.invalid && f.Quantity.touched">
            <div *ngIf="f.Quantity.errors && f.Quantity.touched" class="control-error-message">
                <div *ngIf="f.Quantity.errors.required">Please enter quantity</div>
                <div *ngIf="f.Quantity.errors.min">Please enter the quantity greater than zero</div>
            </div>
        </div>

        <!-- Cost Price -->
        <div *ngIf="PurchaseOrderReadaccess && showCostPrice">
            <label>Cost price <span class="required">*</span></label>
            <input type="text" formControlName="costprice" class="full-width"
                   [class.with-error]="f.costprice.invalid && f.costprice.touched">
            <div *ngIf="f.costprice.errors && f.costprice.touched" class="control-error-message">
                <div *ngIf="f.costprice.errors.required" translate>Please.enter.cost.price</div>
                <div *ngIf="f.costprice.errors.pattern" translate>Please.enter.a.number</div>
            </div>
        </div>

        <!-- Sale Price -->
        <div>
            <label>Sale price <span class="required">*</span></label>
            <input type="text" formControlName="saleprice" class="full-width"
                   [class.with-error]="f.saleprice.invalid && f.saleprice.touched">
            <div *ngIf="f.saleprice.errors && f.saleprice.touched" class="control-error-message">
                <div *ngIf="f.saleprice.errors.required" translate="">Please.enter.sale.price</div>
                <div *ngIf="f.saleprice.errors.pattern" translate>Please.enter.a.number</div>
            </div>
        </div>
    </form>
    <!-- Buttons -->

    <div class="panel-actions">
        <button class="btn-cancel cancel-color" (click)="sidePanelModalRef.hide()">Cancel</button>
        <button class="btn-save save-color"  (click)="onSave()" [disabled]="form.invalid" [ngClass]="{'button-disabled': form.invalid,'button-enabled':form.valid}">Save</button>
    </div>
</div>
